// 活动中心
import fetch from '../fetch';

import {
  SIGN_ACTIVITY_LIST,
  SIGN_ACTIVITY_UPDATE,
  SIGN_ACTIVITY_UPDATESTATUS,
  SIGN_ACTIVITY_ADD,
  SIGN_ACTIVITY_DETAIL
} from '../url';

// 签到活动列表查询
function getSignActivityList(data) {
  return fetch({
    url: SIGN_ACTIVITY_LIST,
    method: 'post',
    data: data
  });
}

// 添加签到活动
function addSignActivity(data) {
  return fetch({
    url: SIGN_ACTIVITY_ADD,
    method: 'post',
    data: data
  });
}

// 修改签到活动
function updateSignActivity(data) {
  return fetch({
    url: SIGN_ACTIVITY_UPDATE,
    method: 'post',
    data: data
  });
}

// 更新签到活动状态
function updateSignActivityStatus(data) {
  return fetch({
    url: SIGN_ACTIVITY_UPDATESTATUS,
    method: 'post',
    data: data
  });
}

// 签到活动详情查询
function getSignActivityDetail(data) {
  return fetch({
    url: SIGN_ACTIVITY_DETAIL,
    method: 'get',
    params: data
  });
}

const activityCenter = {
  getSignActivityList,
  addSignActivity,
  updateSignActivity,
  updateSignActivityStatus,
  getSignActivityDetail
};

export { activityCenter };
